import axios from "axios";
import firebaseProject from "@/common/firebaseProject";

export type UserInfoType = {
  email: string;
  password?: string;
  userName: string;
  phoneNumber?: string;
  shopId?: string;
  tenantId?: string;
};

export type UserApiResult = {
  success: boolean;
  error?: string;
  user?: UserInfoType;
};

const baseHost = "/api";

export const getUser = async (uid: string): Promise<UserApiResult> => {
  const idToken = await firebaseProject.auth().currentUser?.getIdToken();
  if (!idToken) {
    return { success: false, error: "Can not get user id token." };
  }
  const url = baseHost + "/user/" + uid;
  const result = await axios.get(url, {
    headers: { Authorization: idToken }
  });
  return result.data;
};

export const createUser = async (
  info: UserInfoType
): Promise<UserApiResult> => {
  const idToken = await firebaseProject.auth().currentUser?.getIdToken();
  if (!idToken) {
    return { success: false, error: "Can not get user id token." };
  }
  const url = baseHost + "/user/create";
  const result = await axios
    .post(url, info, {
      headers: { Authorization: idToken }
    })
    .catch(e => {
      console.error(e.response.data);
      throw {
        success: false,
        statusText:
          "ユーザーを登録できません。\nメールアドレスが重複していないかご確認ください。"
      };
    });
  if (result.data.success === false) {
    return result.data;
  } else {
    return { success: true, user: info };
  }
};

export const updateUser = async (
  uid: string,
  info: UserInfoType
): Promise<UserApiResult> => {
  const idToken = await firebaseProject.auth().currentUser?.getIdToken();
  if (!idToken) {
    debugger;
    return { success: false, error: "Can not get user id token." };
  }
  const url = baseHost + `/user/${uid}/update`;
  const result = await axios
    .put(url, info, {
      headers: { Authorization: idToken }
    })
    .catch(e => {
      console.error(e.response.data);
      throw {
        success: false,
        statusText:
          "ユーザーを更新できません。\nユーザーが削除されていないか、メールアドレスが正しいかご確認ください。"
      };
    });
  if (result.data.success === false) {
    return result.data;
  } else {
    return { success: true, user: info };
  }
};

export const updatePassword = async (
  uid: string,
  password: string
): Promise<UserApiResult> => {
  const idToken = await firebaseProject.auth().currentUser?.getIdToken();
  if (!idToken) {
    return { success: false, error: "Can not get user id token." };
  }
  const url = baseHost + `/user/${uid}/update_password`;
  const result = await axios
    .put(
      url,
      {
        email: "",
        userName: "",
        password: password
      },
      {
        headers: { Authorization: idToken }
      }
    )
    .catch(e => {
      console.error(e.response.data);
      throw {
        success: false,
        statusText:
          "パスワードを更新できません。\nパスワードに不正な文字が含まれていないかご確認ください。"
      };
    });
  if (result.data.success === false) {
    return result.data;
  } else {
    return { success: true };
  }
};

export const deleteUser = async (uid: string): Promise<UserApiResult> => {
  const idToken = await firebaseProject.auth().currentUser?.getIdToken();
  if (!idToken) {
    return { success: false, error: "Can not get user id token." };
  }
  const url = baseHost + `/user/${uid}`;
  const result = await axios
    .delete(url, {
      headers: { Authorization: idToken }
    })
    .catch(e => {
      console.error(e.response.data);
      throw {
        success: false,
        statusText:
          "ユーザーを削除できません。\nすでに削除されていないかご確認ください。"
      };
    });
  if (result.data.success === false) {
    return result.data;
  } else {
    return { success: true };
  }
};
